import { render } from "./OrderTile.vue?vue&type=template&id=66d7e671&scoped=true&ts=true"
import script from "./OrderTile.vue?vue&type=script&lang=ts"
export * from "./OrderTile.vue?vue&type=script&lang=ts"

import "./OrderTile.vue?vue&type=style&index=0&id=66d7e671&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/.pnpm/vue-loader@17.4.2_vue@3.3.0_webpack@5.92.1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66d7e671"]])

export default __exports__